export const KICKOFF = "KICK_OFF";
export const ENDOFFIRSTHALF = "END_OF_FIRST_HALF";
export const STARTOFSECONDHALF = "START_OF_SECOND_HALF";
export const STARTOFPENALTYSHOOTOUT = "START_OF_PENALTY_SHOOTOUT";
export const ENDOFSECONDHALF = "END_OF_SECOND_HALF";
export const FULLTIME = "FULL_TIME";
export const GOAL = "GOAL";
export const OWNGOAL = "OWN_GOAL";
export const PENALTY = "PENALTY";
export const SUBON = "SUBSTITUTION_ON";
export const SUBOFF = "SUBSTITUTION_OFF";
export const YELLOWCARD = "YELLOW_CARD";
export const SECONDYELLOWCARD = "SECOND_YELLOW_CARD";
export const REDCARD = "RED_CARD";

export const LIVE_REFRESH_INTERVAL_MILLIS = 10000;
export const FIXTURES_REFRESH_INTERVAL_MILLIS = 30000;
export const COMPETITIONS_REFRESH_INTERVAL_MILLIS = 30000;

export const MATCH_STATE_ALL = [
  "ABANDONED",
  "PREMATCH",
  "FIRSTHALF",
  "HALFTIME",
  "SECONDHALF",
  "FULLTIME90",
  "EXTRAFIRSTHALF",
  "EXTRAHALFTIME",
  "EXTRASECONDHALF",
  "FULLTIMEPENS",
  "SHOOTOUT",
  "LIVE",
  "FULLTIME"
];

export const MATCH_STATE_UPNEXT = [
  "PREMATCH"
];

export const MATCH_STATE_LIVE = [
  "FIRSTHALF",
  "HALFTIME",
  "SECONDHALF",
  "FULLTIME90",
  "EXTRAFIRSTHALF",
  "EXTRAHALFTIME",
  "EXTRASECONDHALF",
  "FULLTIMEPENS",
  "SHOOTOUT",
  "LIVE"
];

export const MATCH_STATE_FINISHED = [
  "FULLTIME"
];

export const MATCH_FILTER_EMPTY_MESSAGE = {
  noTabs: "Nothing to show for this competition",
  results: "There are no results to show at the moment.",
  fixtures: "There are no fixtures to show.",
  resultsmonth: "There are currently no results to show for this month.",
  fixturesmonth: "There are no fixtures to show for this month.",

  all: "There are no matches at the moment.",
  upNext: "There are no scheduled matches at the moment.",
  ongoing: "There are no live matches at the moment.",
  finished: "There are no finished matches at the moment."
};

export const GOAL_ALERT_TIME = 5000;

export const MATCH_TYPE_REGULAR = "Regular";



// WEBPACK FOOTER //
// ./modules/Football/consts.js